// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer[data-v-66d680e7]{position:relative}footer .chat-trigger[data-v-66d680e7]{z-index:2;position:fixed;right:35px;bottom:20px;display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
